// extracted by mini-css-extract-plugin
export default {"link":"how-to-use_link__Pv2ul"};